<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 2C16.6569 2 18 3.34315 18 5V19C18 20.6569 16.6569 22 15 22H9C7.34315 22 6 20.6569 6 19V5C6 3.34315 7.34315 2 9 2H15ZM15 4H9C8.44772 4 8 4.44772 8 5V19C8 19.5523 8.44772 20 9 20H15C15.5523 20 16 19.5523 16 19V5C16 4.44772 15.5523 4 15 4ZM3 6C3.55228 6 4 6.44772 4 7V17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17V7C2 6.44772 2.44772 6 3 6ZM21 6C21.5523 6 22 6.44772 22 7V17C22 17.5523 21.5523 18 21 18C20.4477 18 20 17.5523 20 17V7C20 6.44772 20.4477 6 21 6Z"
    fill="currentColor"
  />
</svg>
